import React, { memo, useState } from 'react'
import Modal from './Modal'
import CarModalInput from '../inputs/CarModalInput'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import { addCarCategorySubmitHandler } from '../../functions/AddProductModalSubmit'

function AddCarCategoryModal({ carModels, setCarModels, setShowModal }) {
  const [categoryName, setCategoryName] = useState('')

  const [error, setError] = useState({})

  const [isSubmit, setIsSubmit] = useState(false)

  const inputHandler = (e) => {
    let name = e.target.name
    let value = e.target.value

    setCategoryName(value)

    setError({
      ...error,
      [name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    await addCarCategorySubmitHandler(
      categoryName,
      carModels,
      setCarModels,
      setIsSubmit,
      setError,
      error,
      setShowModal
    )
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-2xl font-semibold text-center dark:text-slate-200">
            افزودن دسته بندی
          </h3>
        </div>

        {/*body*/}
        <div className="relative p-6 flex flex-col">
          <CarModalInput
            title={'نام دسته بندی'}
            type={'text'}
            isSubmit={isSubmit}
            name={'categoryName'}
            value={categoryName}
            inputHandler={inputHandler}
            error={error}
          />
        </div>

        {/*footer*/}
        <ModalSubmitFormButton setShowModal={setShowModal} isSubmit={isSubmit} />
      </form>
    </Modal>
  )
}

export default memo(AddCarCategoryModal)
